import ProcessSection from './ProcessSection';

export default ProcessSection;
